(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hospitality-assortment-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[id^="HospitalityAssortment-"]');

    roots.forEach((root) => {
      const inputs = Array.from(root.querySelectorAll('[data-variant-id]'));
      const count = root.querySelector('[data-assortment-count]');
      const message = root.querySelector('[data-assortment-message]');
      const status = root.querySelector('[data-assortment-status]');
      const total = root.querySelector('[data-assortment-total]');
      const addButton = root.querySelector('[data-assortment-add]');
      const resetButton = root.querySelector('[data-assortment-reset]');
      const minimum = Number(root.dataset.minimumUnits || 12);
      const currencyCode = root.dataset.currencyCode || 'USD';
      const currencyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode,
      });
      const messageMet = root.dataset.messageMet || '';
      const messageRemaining = root.dataset.messageRemaining || '';
      const messageAdding = root.dataset.messageAdding || '';
      const messageAdded = root.dataset.messageAdded || '';
      const messageError = root.dataset.messageError || '';
      const storageKey = `yc-assortment:${window.location.pathname}:${root.id}`;
      let currentOrderUnits = Number(root.dataset.currentOrderUnits || 0);

      try {
        const savedQuantities = JSON.parse(window.localStorage.getItem(storageKey) || '{}');
        inputs.forEach((input) => {
          const savedQuantity = savedQuantities[input.dataset.variantId];
          if (Number.isInteger(savedQuantity) && savedQuantity >= 0) {
            input.value = String(savedQuantity);
          }
        });
      } catch {
        window.localStorage.removeItem(storageKey);
      }

      const selectedUnits = () => inputs.reduce((total, input) => {
        return total + Math.max(0, Number.parseInt(input.value || '0', 10));
      }, 0);

      const selectedPrice = () => inputs.reduce((sum, input) => {
        const quantity = Math.max(0, Number.parseInt(input.value || '0', 10));
        return sum + (quantity * Number(input.dataset.variantPrice || 0));
      }, 0);

      const saveSelection = () => {
        const quantities = {};
        inputs.forEach((input) => {
          quantities[input.dataset.variantId] = Math.max(0, Number.parseInt(input.value || '0', 10));
        });
        window.localStorage.setItem(storageKey, JSON.stringify(quantities));
      };

      const updateCounter = () => {
        const selection = selectedUnits();
        const projectedTotal = currentOrderUnits + selection;
        if (count) count.textContent = String(projectedTotal);
        if (total) total.textContent = currencyFormatter.format(selectedPrice() / 100);
        addButton.disabled = selection === 0;

        if (projectedTotal >= minimum) {
          if (message) message.textContent = messageMet.replace('__COUNT__', String(projectedTotal));
        } else {
          const remaining = minimum - projectedTotal;
          if (message) message.textContent = messageRemaining.replace('__COUNT__', String(remaining));
        }
      };

      inputs.forEach((input) => input.addEventListener('input', () => {
        saveSelection();
        updateCounter();
      }));

      resetButton.addEventListener('click', () => {
        inputs.forEach((input) => {
          input.value = input.dataset.defaultQuantity || '0';
        });
        saveSelection();
        status.textContent = '';
        updateCounter();
      });

      addButton.addEventListener('click', async () => {
        const items = inputs
          .map((input) => ({
            id: Number(input.dataset.variantId),
            quantity: Math.max(0, Number.parseInt(input.value || '0', 10)),
            properties: {_yc_assortment: 'hospitality'},
          }))
          .filter((item) => item.quantity > 0);

        if (items.length === 0) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        status.textContent = messageAdding;

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items}),
          });

          if (!response.ok) throw new Error('Cart request failed');

          const addedUnits = selectedUnits();
          currentOrderUnits += addedUnits;
          inputs.forEach((input) => { input.value = '0'; });
          window.localStorage.removeItem(storageKey);
          status.textContent = messageAdded.replace('__COUNT__', String(addedUnits));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch {
          status.textContent = messageError;
        } finally {
          addButton.removeAttribute('aria-busy');
          updateCounter();
        }
      });

      updateCounter();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hospitality-mix-and-match"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="HospitalityMix-"]').forEach((root) => {
      const inputs = Array.from(root.querySelectorAll('[data-variant-id]'));
      const count = root.querySelector('[data-assortment-count]');
      const message = root.querySelector('[data-assortment-message]');
      const status = root.querySelector('[data-assortment-status]');
      const addButton = root.querySelector('[data-assortment-add]');
      const resetButton = root.querySelector('[data-assortment-reset]');
      const mixAndMatchButton = root.querySelector('[data-mix-and-match-scroll]');
      const minimum = Number(root.dataset.minimumUnits || 12);
      const storageKey = `yc-mix:${window.location.pathname}:${root.id}`;
      let currentOrderUnits = Number(root.dataset.currentOrderUnits || 0);

      try {
        const saved = JSON.parse(window.localStorage.getItem(storageKey) || '{}');
        inputs.forEach((input) => {
          if (Number.isInteger(saved[input.dataset.variantId]) && saved[input.dataset.variantId] >= 0) {
            input.value = String(saved[input.dataset.variantId]);
          }
        });
      } catch { window.localStorage.removeItem(storageKey); }

      const selectedUnits = () => inputs.reduce((total, input) => total + Math.max(0, Number.parseInt(input.value || '0', 10)), 0);
      const saveSelection = () => {
        const values = {};
        inputs.forEach((input) => { values[input.dataset.variantId] = Math.max(0, Number.parseInt(input.value || '0', 10)); });
        window.localStorage.setItem(storageKey, JSON.stringify(values));
      };
      const updateCounter = () => {
        const selection = selectedUnits();
        const projected = currentOrderUnits + selection;
        if (count) count.textContent = String(projected);
        addButton.disabled = selection === 0;
        message.textContent = projected >= minimum
          ? (root.dataset.messageMet || '').replace('__COUNT__', String(projected))
          : (root.dataset.messageRemaining || '').replace('__COUNT__', String(minimum - projected));
      };

      if (mixAndMatchButton) {
        mixAndMatchButton.addEventListener('click', (event) => {
          const target = root.querySelector(`#HospitalityMixProducts-${root.id.replace('HospitalityMix-', '')}`);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({behavior: 'smooth', block: 'start'});
          window.history.replaceState(null, '', `#${target.id}`);
        });
      }

      inputs.forEach((input) => input.addEventListener('input', () => { saveSelection(); updateCounter(); }));
      resetButton.addEventListener('click', () => {
        inputs.forEach((input) => { input.value = '0'; });
        saveSelection(); status.textContent = ''; updateCounter();
      });
      addButton.addEventListener('click', async () => {
        const items = inputs.map((input) => ({
          id: Number(input.dataset.variantId),
          quantity: Math.max(0, Number.parseInt(input.value || '0', 10)),
          properties: {_yc_assortment: 'hospitality-mix'},
        })).filter((item) => item.quantity > 0);
        if (!items.length) return;
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        status.textContent = root.dataset.messageAdding || '';
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items}),
          });
          if (!response.ok) throw new Error('Cart request failed');
          const added = selectedUnits();
          currentOrderUnits += added;
          inputs.forEach((input) => { input.value = '0'; });
          window.localStorage.removeItem(storageKey);
          status.textContent = (root.dataset.messageAdded || '').replace('__COUNT__', String(added));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch { status.textContent = root.dataset.messageError || ''; }
        finally { addButton.removeAttribute('aria-busy'); updateCounter(); }
      });
      updateCounter();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
